import PageHero from "@/components/site/PageHero";
import ApplyForm from "@/components/site/ApplyForm";
import { useSEO } from "@/lib/seo";

export default function ResumeUpload() {
  useSEO({
    title: "Upload Your Resume",
    description: "Don't see a role today? Drop your resume in the PharmacoHires database — we'll reach out when a matching opening opens up.",
    pageKey: "upload-resume",
  });
  return (
    <>
      <PageHero
        overline="Talent Database"
        title="Drop your resume — we'll reach out when there's a match."
        description="No matching opening today? Share your profile and our pharma-domain recruiters will keep you in mind for relevant roles as they open."
      />
      <section className="section-pad">
        <div className="container-page grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="overline mb-3">Why join the database</div>
            <h2 className="font-heading text-2xl font-semibold text-slate-900">Get found first for the next opportunity</h2>
            <ul className="mt-6 space-y-4 text-sm text-slate-700">
              <li className="flex gap-3"><span className="mt-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />Your profile is reviewed by a pharma-domain recruiter, not a keyword bot.</li>
              <li className="flex gap-3"><span className="mt-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />We protect your data and never share it without consent.</li>
              <li className="flex gap-3"><span className="mt-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />Confidential search support for senior candidates.</li>
              <li className="flex gap-3"><span className="mt-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />Zero fees for candidates, ever.</li>
            </ul>
          </div>
          <div className="md:col-span-7">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
              <ApplyForm compact />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
